import type { VoidFunctionComponent } from 'react';
import CallToAction from '../CallToAction';
import Text from '../generic/Text';
import Flex from '../generic/Flex';
import PackageCount from './PackageCount';

/**
 * PackageInventoryCTA is a call-to-action for the
 * Package inventory page.
 *
 * Note that this only accounts for the first page
 * and not the PackageVersion page.
 */
const PackageInventoryCTA: VoidFunctionComponent = () => (
  <CallToAction>
    <Flex align="center" justify="space-between">
      <div>
        <Text.H1>
          <Flex align="flex-start" justify="flex-start" gap="8px">
            Packages
          </Flex>
        </Text.H1>
        <Text.Text>View all packages used across your organization.</Text.Text>
      </div>
      <PackageCount />
    </Flex>
  </CallToAction>
);

export default PackageInventoryCTA;
